<template>
  <Modal :value="value" width="lg" @input="$emit('input', $event)">
    <span slot="header">Detalhes da Ação</span>

    <template v-if="event">
      <h6 class="bold">{{ title }}</h6>

      <div class="row mb-3">
        <div v-for="field in identification" :key="field.label" class="col-md-6">
          <small>{{ field.label }}:</small>
          <strong class="ml-1">{{ field.value }}</strong>
        </div>
      </div>

      <table class="table table-borderless table-border table-align">
        <thead>
        <tr>
          <th>Campo</th>
          <th>Valor Anterior</th>
          <th>Novo Valor</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="change in event.changes" :key="change.field">
          <td>{{ change.label }}</td>
          <td><s>{{ change.from }}</s></td>
          <td>{{ change.to }}</td>
        </tr>
        </tbody>
      </table>

      <div class="mt-3">
        <div><strong>Data:</strong> {{ event.createdAt | datetime }}</div>
        <div><strong>Usuário:</strong> {{ user }}</div>
      </div>
    </template>

    <template slot="footer">
      <button class="btn btn-primary" @click="$emit('input', false)">Fechar</button>
    </template>
  </Modal>
</template>

<script>
  import Modal from '@/components/shares/specialTag/Modal'

  const TITLES = {
    vehicle: {
      update: 'Veículo Alterado',
      disable: 'Veículo Inativado',
      enable: 'Veículo Reativado'
    },
    driver: {
      update: 'Motorista Alterado'
    },
    company: {
      update: 'Empresa Alterada',
      disable: 'Empresa Inativada',
      enable: 'Empresa Reativada'
    },
    user: {
      update: 'Usuário Alterado'
    }
  }

  const COMPANY_LABEL = /^(.*) - (\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2})$/

  export default {
    components: { Modal },
    computed: {
      identification() {
        const label = (this.event?.recordLabel || '').trim()
        if (!label)
          return []

        if (this.event.recordType === 'vehicle') {
          const [plate, renavam] = label.split(' / ')
          if (plate && renavam)
            return [{ label: 'Placa', value: plate }, { label: 'RENAVAM', value: renavam }]
        }

        if (this.event.recordType === 'company') {
          const match = label.match(COMPANY_LABEL)
          if (match)
            return [{ label: 'Razão social', value: match[1] }, { label: 'CNPJ', value: match[2] }]
        }

        if (this.event.recordType === 'driver')
          return [{ label: 'CPF', value: label }]

        return [{ label: 'Registro', value: label }]
      },
      title() {
        return TITLES[this.event?.recordType]?.[this.event?.action] || 'Registro Alterado'
      },
      user() {
        if (this.event?.pretenderEmail)
          return `${this.event.userEmail} (via ${this.event.pretenderEmail})`

        return this.event?.userEmail
      }
    },
    name: 'DetailModal',
    props: {
      event: { default: null, type: Object },
      value: { default: false, type: Boolean }
    }
  }
</script>
